// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__Lout5","noBorder":"style__noBorder__OzDJf","logo":"style__logo__51jx3"};